import { render, staticRenderFns } from "./settings.view.vue?vue&type=template&id=2cd390b7&scoped=true&"
import script from "./settings.view.vue?vue&type=script&lang=ts&"
export * from "./settings.view.vue?vue&type=script&lang=ts&"
import style0 from "./settings.view.vue?vue&type=style&index=0&id=2cd390b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd390b7",
  null
  
)

export default component.exports